import { ABOptions, type TestConfig, TestsNames } from '@/ab-tests/types';

export const COOKIE_TESTS_KEY = 'ab_tests';
export const COOKIE_EXPIRATION_DAYS = 365;

export const testsConfig: TestConfig[] = [
  {
    name: TestsNames.LEAVE_REVIEWS_TEST,
    options: [ABOptions.A, ABOptions.B],
    enabled: true,
    defaultValue: ABOptions.A,
  },
];
